<script>
export default {
  computed: {
    standAlone: () => {
      const userAgent = window.navigator.userAgent.toLowerCase()
      const isIos = /iphone|ipad|ipod/.test(userAgent)

      if (
        isIos &&
        'standalone' in window.navigator &&
        window.navigator.standalone
      ) {
        return true
      }
      if (window.matchMedia('(display-mode: standalone)').matches) {
        return true
      }
      return false
    },
  },
}
</script>

<template>
  <!-- No explicit background: the bar follows the active theme, where a
       hardcoded white one stayed lit under a dark app. -->
  <v-bottom-navigation v-if="standAlone" fixed app>
    <v-btn variant="text" size="small" @click="$router.go(-1)">
      <v-icon>$prev</v-icon>
    </v-btn>
    <v-spacer></v-spacer>
    <v-btn variant="text" size="small" @click="$router.go(1)">
      <v-icon>$next</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>
